const GoToLinks = {
    globeWebsite: `https://globecapital.com/`,
    accountOpening: 'https://signup.globecapital.com/default?c=ZPDX',
    downloadAppLink: 'https://play.google.com/store/apps/details?id=com.globecapital.prod&hl=en_IN',
    whatsappLink: 'https://api.whatsapp.com/send/?phone=918805929292',
    instagramLink: 'https://www.instagram.com/wolfinvestment.in?igsh=MTlrcGszZHl3YnBk&utm_source=qr',
}

export default GoToLinks;